import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PolitiqueConfidentialite = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      <div className="pt-32 pb-16 bg-gradient-to-b from-neutral-900 to-black">
        <div className="max-w-4xl mx-auto px-4 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            Retour
          </Link>

          <h1 className="font-display text-5xl md:text-6xl font-bold uppercase text-white mb-12 tracking-wide">
            Politique de Confidentialité
          </h1>

          <div className="space-y-8">
            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Qui sommes-nous ?
              </h2>
              <p className="text-gray-300 leading-relaxed">
                L'adresse de notre site Web est : <a href="https://www.gaillleyton.com" className="text-rose-400 hover:text-rose-300" target="_blank" rel="noopener noreferrer">https://www.gaillleyton.com</a>.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Utilisation des données personnelles collectées
              </h2>
              
              <div className="space-y-6 mt-6">
                <div>
                  <h3 className="text-xl font-semibold text-rose-400 mb-3">Commentaires</h3>
                  <p className="text-gray-300 leading-relaxed mb-3">
                    Quand vous laissez un commentaire sur notre site web, les données inscrites dans le formulaire de commentaire, mais aussi votre adresse IP et l'agent utilisateur de votre navigateur sont collectés pour nous aider à la détection des commentaires indésirables.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Une chaîne anonymisée créée à partir de votre adresse de messagerie (également appelée hash) peut être envoyée au service Gravatar pour vérifier si vous utilisez ce dernier. Après validation de votre commentaire, votre photo de profil sera visible publiquement à coté de votre commentaire.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-rose-400 mb-3">Médias</h3>
                  <p className="text-gray-300 leading-relaxed">
                    Si vous êtes un utilisateur ou une utilisatrice enregistré·e et que vous téléversez des images sur le site web, nous vous conseillons d'éviter de téléverser des images contenant des données EXIF de coordonnées GPS. Les visiteurs de votre site web peuvent télécharger et extraire des données de localisation depuis ces images.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-rose-400 mb-3">Cookies</h3>
                  <div className="text-gray-300 leading-relaxed space-y-3">
                    <p>
                      Si vous déposez un commentaire sur notre site, il vous sera proposé d'enregistrer votre nom, adresse de messagerie et site web dans des cookies. C'est uniquement pour votre confort afin de ne pas avoir à saisir ces informations si vous déposez un autre commentaire plus tard. Ces cookies expirent au bout d'un an.
                    </p>
                    <p>
                      Si vous avez un compte et que vous vous connectez sur ce site, un cookie temporaire sera créé afin de déterminer si votre navigateur accepte les cookies. Il ne contient pas de données personnelles et sera supprimé automatiquement à la fermeture de votre navigateur.
                    </p>
                    <p>
                      Lorsque vous vous connecterez, nous mettrons en place un certain nombre de cookies pour enregistrer vos informations de connexion et vos préférences d'écran. La durée de vie d'un cookie de connexion est de deux jours, celle d'un cookie d'option d'écran est d'un an.
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-rose-400 mb-3">Contenu embarqué depuis d'autres sites</h3>
                  <p className="text-gray-300 leading-relaxed mb-3">
                    Les articles de ce site peuvent inclure des contenus intégrés (par exemple des vidéos, images, articles…). Le contenu intégré depuis d'autres sites se comporte de la même manière que si le visiteur se rendait sur cet autre site.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Ces sites web pourraient collecter des données sur vous, utiliser des cookies, embarquer des outils de suivis tiers, suivre vos interactions avec ces contenus embarqués si vous disposez d'un compte connecté sur leur site web.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Durées de stockage de vos données
              </h2>
              <div className="text-gray-300 leading-relaxed space-y-4">
                <p>
                  Si vous laissez un commentaire, le commentaire et ses métadonnées sont conservés indéfiniment. Cela permet de reconnaître et approuver automatiquement les commentaires suivants au lieu de les laisser dans la file de modération.
                </p>
                <p>
                  Pour les utilisateurs et utilisatrices qui s'enregistrent sur notre site (si cela est possible), nous stockons également les données personnelles indiquées dans leur profil. Tous les utilisateurs et utilisatrices peuvent voir, modifier ou supprimer leurs informations personnelles à tout moment (à l'exception de leur nom d'utilisateur·ice). Les gestionnaires du site peuvent aussi voir et modifier ces informations.
                </p>
              </div>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Les droits que vous avez sur vos données
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Si vous avez un compte ou si vous avez laissé des commentaires sur le site, vous pouvez demander à recevoir un fichier contenant toutes les données personnelles que nous possédons à votre sujet, incluant celles que vous nous avez fournies. Vous pouvez également demander la suppression des données personnelles vous concernant. Cela ne prend pas en compte les données stockées à des fins administratives, légales ou pour des raisons de sécurité.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Transmission de vos données personnelles
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Les commentaires des visiteurs peuvent être vérifiés à l'aide d'un service automatisé de détection des commentaires indésirables.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Informations de contact
              </h2>
              <div className="text-gray-300 space-y-2">
                <p><strong className="text-white">Gail Lleyton</strong></p>
                <p className="italic">Paris – Ile de France (France)</p>
                <p>Mail : <a href="mailto:Contact@gaillleyton.com" className="text-rose-400 hover:text-rose-300">Contact@gaillleyton.com</a></p>
              </div>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                Informations supplémentaires
              </h2>
              <ul className="text-gray-300 space-y-2">
                <li>• Comment nous protégeons vos données</li>
                <li>• Procédures mises en œuvre en cas de fuite de données</li>
                <li>• Les services tiers qui nous transmettent des données</li>
                <li>• Opérations de marketing automatisé et/ou de profilage réalisées à l'aide des données personnelles</li>
                <li>• Affichage des informations liées aux secteurs soumis à des régulations spécifiques</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialite;
